import adamello_ski from './svg/adamello-ski.svg';
import adamello_ski_b2b from './svg/adamello-ski-b2b.svg';
import anef from './svg/anef.svg';
import aprica from './svg/aprica.svg';
import bardonecchia from './svg/bardonecchia.svg';
import beneficy from './svg/beneficy.svg';
import beneficy_bikeit from './svg/beneficy-bikeit.svg';
import beneficy_discovera from './svg/beneficy-discovera.svg';
import beneficy_snowit from './svg/beneficy-snowit.svg';
import bikeit from './svg/bikeit.svg';
import bolonice from './svg/bolonice.svg';
import bormioski from './svg/bormioski.svg';
import bormioski_summer from './svg/bormioski~summer.svg';
import cervino_ski from './svg/cervino-ski-paradise.svg';
import cervino_ski_b2b from './svg/cervino-ski-paradise-b2b.svg';
import ciclista from './svg/ciclista.svg';
import cimone from './svg/cimone.svg';
import cornoallescale from './svg/cornoallescale.svg';
import cortina from './svg/cortina.svg';
import courmayeur from './svg/courmayeur.svg';
import demo from './svg/demo.svg';
import demo_b2b from './svg/demo-b2b.svg';
import discovera from './svg/discovera.svg';
import dovesciare from './svg/dovesciare.svg';
import edenred from './svg/edenred.svg';
import endurorepublic from './svg/endurorepublic.svg';
import endurorepublic_hotel from './svg/endurorepublic-hotel.svg';
import folgaria from './svg/folgaria.svg';
import gazzettaadventure from './svg/gazzettaadventure.svg';
import getyourguide from './svg/getyourguide.svg';
import giteintreno from './svg/giteintreno.svg';
import gks from './svg/gks.svg';
import happyrental from './svg/happyrental.svg';
import jakala_discovera from './svg/jakala-discovera.svg';
import jakala_snowit from './svg/jakala-snowit.svg';
import jointly from './svg/jointly.svg';
import jointly_discovera from './svg/jointly-discovera.svg';
import kiterevolution from './svg/kiterevolution.svg';
import kts from './svg/kts.svg';
import livigno from './svg/livigno.svg';
import livigno_b2b from './svg/livigno-b2b.svg';
import madonnadicampiglio_b2b from './svg/madonnadicampiglio-b2b.svg';
import madonnadicampiglio_b2b_agenzie from './svg/madonnadicampiglio-b2b-agenzie.svg';
import madonnadicampiglio_gruppi from './svg/madonnadicampiglio-gruppi.svg';
import mangaclimbing_tribala from './svg/mangaclimbing-tribala.svg';
import mc4season from './svg/mc4season.svg';
import madonnadicampiglio_cambiomerce1 from './svg/mdc-cambiomerce1.svg';
import madonnadicampiglio_cambiomerce2 from './svg/mdc-cambiomerce2.svg';
import madonnadicampiglio_coupon from './svg/mdc-coupon.svg';
import padel4fun from './svg/padel4fun.svg';
import padelacademy from './svg/padelacademy.svg';
import paganella from './svg/paganella.svg';
import pianidibobbio from './svg/pianidibobbio.svg';
import pianidibobbio_b2b from './svg/pianidibobbio-b2b.svg';
import santacaterina from './svg/santacaterina.svg';
import skifun from './svg/skifun.svg';
import skipasslombardia from './svg/skipasslombardia.svg';
import snowit from './svg/snowit.svg';
import snowit_panel from './svg/snowit_panel.svg';
import snowit_panel_dev from './svg/snowit_panel_dev.svg';
import snowit_europe from './svg/snowit-europe.svg';
import snowit_go from './svg/snowit-go.svg';
import snowit_travel from './svg/snowit-travel.svg';
import snowit_summer from './svg/snowit~summer.svg';
import sportit_admin from './svg/sportit_admin.svg';
import sportit_admin_dev from './svg/sportit_admin_dev.svg';
import sportmission from './svg/sportmission.svg';
import tantosvago from './svg/tantosvago.svg';
import tantosvago_bikeit from './svg/tantosvago-bikeit.svg';
import tantosvago_tribala from './svg/tantosvago-tribala.svg';
import tribala from './svg/tribala.svg';
import unipol from './svg/unipol.svg';
import universitybox from './svg/universitybox.svg';
import xtremelement from './svg/xtremelement.svg';

const svgs = {
  'adamello-ski': adamello_ski,
  'adamello-ski-b2b': adamello_ski_b2b,
  'adamello-ski~summer': adamello_ski,
  'bardonecchia~summer': bardonecchia,
  'beneficy-bikeit': beneficy_bikeit,
  'beneficy-discovera': beneficy_discovera,
  'beneficy-snowit': beneficy_snowit,
  'bormioski~summer': bormioski_summer,
  'cervino-ski-paradise': cervino_ski,
  'cervino-ski-paradise-b2b': cervino_ski_b2b,
  'cornoallescale~summer': cornoallescale,
  'demo-b2b': demo_b2b,
  'endurorepublic-tribala': endurorepublic,
  'endurorepublic-hotel': endurorepublic_hotel,
  'jakala-discovera': jakala_discovera,
  'jakala-snowit': jakala_snowit,
  'jointly-discovera': jointly_discovera,
  'livigno-b2b': livigno_b2b,
  'livigno~summer': livigno,
  'madonnadicampiglio-b2b': madonnadicampiglio_b2b,
  'madonnadicampiglio-b2b-agenzie': madonnadicampiglio_b2b_agenzie,
  'madonnadicampiglio-gruppi': madonnadicampiglio_gruppi,
  'mangaclimbing-tribala': mangaclimbing_tribala,
  'mdc-cambiomerce1': madonnadicampiglio_cambiomerce1,
  'mdc-cambiomerce2': madonnadicampiglio_cambiomerce2,
  'mdc-coupon': madonnadicampiglio_coupon,
  'pianidibobbio-b2b': pianidibobbio_b2b,
  'pianidibobbio~summer': pianidibobbio,
  'santacaterina~summer': santacaterina,
  'snowit-europe': snowit_europe,
  'snowit-go': snowit_go,
  'snowit-panel': snowit_panel,
  'snowit-panel-dev': snowit_panel_dev,
  'snowit-travel': snowit_travel,
  'snowit~summer': snowit_summer,
  'sportit-admin': sportit_admin,
  'sportit-admin-dev': sportit_admin_dev,
  'tantosvago-bikeit': tantosvago_bikeit,
  'tantosvago-tribala': tantosvago_tribala,
  anef: anef,
  aprica: aprica,
  bardonecchia: bardonecchia,
  beneficy: beneficy,
  bikeit: bikeit,
  bolonice: bolonice,
  bormioski: bormioski,
  ciclista: ciclista,
  cimone: cimone,
  cornoallescale: cornoallescale,
  cortina: cortina,
  courmayeur: courmayeur,
  demo: demo,
  discovera: discovera,
  dovesciare: dovesciare,
  edenred: edenred,
  folgaria: folgaria,
  gazzettaadventure: gazzettaadventure,
  getyourguide: getyourguide,
  giteintreno: giteintreno,
  gks: gks,
  happyrental: happyrental,
  jointly: jointly,
  kiterevolution: kiterevolution,
  kts: kts,
  livigno: livigno,
  mc4season: mc4season,
  padel4fun: padel4fun,
  padelacademy: padelacademy,
  paganella: paganella,
  pianidibobbio: pianidibobbio,
  santacaterina: santacaterina,
  skifun: skifun,
  skipasslombardia: skipasslombardia,
  snowit: snowit,
  sportmission: sportmission,
  tantosvago: tantosvago,
  tribala: tribala,
  unipol: unipol,
  universitybox: universitybox,
  xtremelement: xtremelement,
} as const;

export type SvgLogosList = keyof typeof svgs;
export default svgs;
